import { useEffect, useState } from "react";
import settings from "../utils/settings";

const useMerchantSetting = () => {
  const [setting, setSetting] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  useEffect(() => {
    const getSetting = async () => {
      const { token } = settings();
      try {
        const result = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/merchant-setting/self`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        const jsonResult = await result.json();
        setSetting(jsonResult.payload.merchant_config);
        return setLoading(false);
      } catch (error) {
        setError(error);
        return setLoading(false);
      }
    };
    getSetting();
  }, []);
  return { setting, loading, error };
};

export default useMerchantSetting;
